// @flow
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import {
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemDestroyDone,
    simpleOnItemDestroyFail,
    simpleOnItemDestroyRequest,
    simpleOnItemDestroySuccess,
}                  from '../../utils';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    item_created:     null,
    item_create_busy: false,
    error:            null,
});

export default class DocumentsReducer extends Reducer {
    NAME = 'Documents';

    alias = {
        [ TYPES.DOCUMENT_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.DOCUMENT_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.DOCUMENT_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.DOCUMENT_CREATE_DONE ]:    'onItemCreateDone',

        [ TYPES.DOCUMENT_DESTROY_REQUEST ]: 'onItemDestroyRequest',
        [ TYPES.DOCUMENT_DESTROY_SUCCESS ]: 'onItemDestroySuccess',
        [ TYPES.DOCUMENT_DESTROY_FAIL ]:    'onItemDestroyFailure',
        [ TYPES.DOCUMENT_DESTROY_DONE ]:    'onItemDestroyDone',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemDestroyRequest = simpleOnItemDestroyRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemDestroySuccess = simpleOnItemDestroySuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemDestroyFailure = simpleOnItemDestroyFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemDestroyDone = simpleOnItemDestroyDone(DEFAULT_STATE);

}
